'use strict';

function _key(key) {
    return (app.company.id || '') + ':' + key;
}

function getItem(key) {
    return window.localStorage.getItem(_key(key));
}

function setItem(key, data) {
    return window.localStorage.setItem(_key(key), data);
}

function removeItem(key) {
    return window.localStorage.removeItem(_key(key));
}

module.exports = {
    getItem:    getItem,
    setItem:    setItem,
    removeItem: removeItem
};



// WEBPACK FOOTER //
// ./app/helpers/localStorageUtil.js